import { Link } from "react-router-dom";
import RichText from "@/components/RichText";

// Mentions légales (/mentions-legales) du moteur "default" — même mise en
// page que la politique de confidentialité (PrivacyContentSection.jsx) :
// colonne unique de 760px, sur-titre doré, H1 serif, une section par bloc
// "legal_block". Le contenu vient du Studio (page « Mentions légales »),
// propre à CHAQUE thème — voir backend/services/theme_engines/shared_pages.py.
//
// Valeurs par défaut identiques à LEGAL_CONTENT_DEFAULT_PROPS côté serveur —
// voir HeroSection.jsx pour l'explication du repli.
const DEFAULTS = {
  legal_eyebrow: "Informations légales",
  legal_heading: "Mentions légales",
  legal_intro: "",
  legal_back_label: "Retour à l'accueil",
  legal_back_url: "/",
};

const isInternal = (url = "") => url.startsWith("/") && !url.startsWith("//");

export default function LegalContentSection({ props = {}, blocks = [] }) {
  const t = { ...DEFAULTS, ...props };
  const items = (blocks || []).filter((b) => b.type === "legal_block" && b.enabled !== false);
  const backClass =
    "inline-flex text-xs uppercase tracking-[0.1em] border border-ink/20 text-ink hover:border-ink transition-colors rounded-full px-5 py-2.5";

  return (
    <section className="max-w-[760px] mx-auto px-6 md:px-10 py-14 md:py-20">
      <RichText as="p" className="block text-xs uppercase tracking-[0.25em] text-gold font-medium mb-4" html={t.legal_eyebrow} />
      <RichText as="h1" className="block font-serif text-3xl md:text-4xl font-medium text-ink mb-8" html={t.legal_heading} />
      {t.legal_intro && (
        <RichText
          as="div"
          preserveParagraphs
          className="text-ink/80 leading-relaxed text-sm md:text-base mb-10 [&_p]:mb-3 [&_p:last-child]:mb-0 [&_a]:underline [&_a]:underline-offset-2 [&_a:hover]:text-copper"
          html={t.legal_intro}
        />
      )}

      <div className="space-y-10 text-ink/80 leading-relaxed">
        {items.map((b) => (
          <div key={b.id} data-block-key={b.id}>
            <RichText as="h2" className="block font-serif text-xl text-ink mb-3" html={b.props?.title} />
            <RichText
              as="div"
              preserveParagraphs
              className="text-sm md:text-base [&_p]:mb-2.5 [&_p:last-child]:mb-0 [&_a]:underline [&_a]:underline-offset-2 [&_a:hover]:text-copper"
              html={b.props?.body}
            />
          </div>
        ))}
      </div>

      {t.legal_back_label && (
        <div className="mt-12">
          {isInternal(t.legal_back_url || "/") ? (
            <Link to={t.legal_back_url || "/"} className={backClass}>{t.legal_back_label}</Link>
          ) : (
            <a href={t.legal_back_url} className={backClass}>{t.legal_back_label}</a>
          )}
        </div>
      )}
    </section>
  );
}
